import GlobalStyle from './styles/globalStyle';
import routes from '@src/routes';
// import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(timezone);

export default function App() {
  const router = createBrowserRouter(routes);
  return (
    <>
      <GlobalStyle />
      <RouterProvider router={router} />
    </>
  );
}
